import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const MyLink = styled(Link)`
  pointer-events: ${(props) => (props.disabled ? 'none' : 'all')};
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  &:hover {
    ${(props) =>
      props.disabled
        ? null
        : {
            color: '#df8c07',
            transform: 'scale(1.2)',
            transition: 'all 0.3s ease-out',
          }};
  }
  text-decoration: none;
`;
